export enum PersonalInformationFormInput {
  FirstName = 'First Name',
  LastName = 'Last Name',
  Phone = 'Phone',
  Position = 'Position',
}
